import * as Tone from "tone"
import { shuffleArray } from "../../common/utils";
import { featuresContext as features } from "../features";
import violin1 from "../../assets/violin1.mp3"

const {seed, baseHue } = features;
const baseFreq = Tone.Frequency(baseHue).toNote().charAt(0)

// Sampler
const sampler = new Tone.Sampler({
  urls: {
    "A#5": violin1,
  },
  onerror: (error) => {
    console.warn("ERROR:", error);
  },
  envelope: {
    attack: "4n",
    release: "4n",
  },
  volume: -13,
}).toDestination();
const samplerEffect = new Tone.FeedbackDelay({
  delayTime: 0.7,
  feedback: 0.9,
  wet: 1,
});
const samplerReverb = new Tone.Reverb({
  decay: 10,
  wet: 1,
});
const samplerAutoFilter = new Tone.AutoFilter("64n", 200, 1)
const samplerNote = `${baseFreq}2`;
const shuffledSamplerNotes = shuffleArray(
  [
    [
      null,
      [samplerNote, samplerNote, samplerNote],
      Tone.Frequency(samplerNote).transpose(5),
      [samplerNote, null, samplerNote],
      null,
      Tone.Frequency(samplerNote).transpose(5),
      null,
      null,
      Tone.Frequency(samplerNote).transpose(-5),
    ],
    [
      Tone.Frequency(samplerNote).transpose(24),
      null,
      [
        Tone.Frequency(samplerNote).transpose(24),
        Tone.Frequency(samplerNote).transpose(29),
        Tone.Frequency(samplerNote).transpose(36),
      ],
      null,
    ],
    [null, null, null, Tone.Frequency(samplerNote).transpose(-12)],
    [Tone.Frequency(samplerNote).transpose(-5), null, null, null],
    [samplerNote, null, null, Tone.Frequency(samplerNote).transpose(7)],
  ],
  seed
);
const samplerGain = new Tone.Gain(0);
sampler.chain(
  samplerEffect,
  samplerReverb,
  samplerAutoFilter,
  samplerGain,
  Tone.Destination
);
const samplerSequence = new Tone.Sequence(
  (time, note) => {
    sampler.triggerAttackRelease(note, "1n");
  },
  shuffledSamplerNotes,
  "1n"
)

export const startSampler = () => {
  samplerEffect.wet.rampTo(1, 4);
  samplerGain.gain.rampTo(1, 1);
  samplerAutoFilter.start()
  samplerSequence.start()
}

export const stopSampler = () => {
  samplerGain.gain.rampTo(0, 3);
  samplerEffect.wet.rampTo(0, 3);
  samplerAutoFilter.stop()
  samplerSequence.stop()
}